function setPresenceColor(presenceStatus) {

    presenceStatus = parseInt(presenceStatus)
			
    var returnColorName = "";
    
        switch (presenceStatus) {
            case 0:
                returnColorName = "grey";
                break;
            case 1:
                returnColorName = "#29a982";
                break;
            case 2:
                returnColorName = "purple";
                break;
            case 3:
                returnColorName = "red";
                break;
            case 4:
                returnColorName = "#f7c70b";
                break;
            case 5:
                returnColorName = "red";
        }
        return returnColorName;
    
}

export default{
    setPresenceColor
}

